import React from 'react';
import useGlobalHook from './UseGlobalHook';

const initialState = {
    adminMode:false,
    voted:false,
    loading: false,
    bool: {
        show: false
    },
    alert: {
        title: '',
        message: '',
        show: false
    },
    appData: {
        headers: {}
    },
    monthNames: ["January", "February", "March", "April", "May", "June",
        "July", "August", "September", "October", "November", "December"
    ]

};

const actions = {


    showBooleanAlert(store, title, message, yes = () => {}, no = () => {}) {
        store.setState({
            bool: {
                title,
                message,
                show: true,
                yes: () => {
                    yes();
                    store.setState({
                        bool: {
                            show: false
                        }
                    })
                },
                no: () => {
                    no();
                    store.setState({
                        bool: {
                            show: false
                        }
                    })
                }
            }
        });
    },

    showAlert: (store, title, message) => {
        store.setState({
            alert: {
                title,
                message,
                show: true
            }
        });
    },

    hideAlert: (store) => {
        store.setState({
            alert: {
                show: false
            }
        });
    },

    setAllData: (store, data) => {
        store.setState({
            appData: data
        });
    },


    setVoted:(store,bool)=>
    {   
        store.setState({voted:bool});

    },

    loading: (store, bool) => {

       /* store.setState({
            loading: bool
        })
        */
    },

    setState:(store,obj)=>{
        store.setState(obj);
    },

    setAdminMode:(store,bool)=>{
        store.setState({adminMode:bool});
    }


};

const useGlobal = useGlobalHook(React, initialState, actions);
const monthNames=initialState.monthNames.map(a=>a.toLowerCase());
export {
    useGlobal,
    monthNames
    

};